import "./EmbedJsSnippet.css";

const EmbedJsSnippet = () => {
  return (
    <div className="embed-js-docs">
      <h1 className="embed-js-title">Embedding via JavaScript Snippet</h1>

      <p className="embed-js-intro">
        Integrate your chatbot into your website efficiently using a JavaScript snippet. Follow the steps below to obtain and deploy the snippet.
      </p>

      <h2 className="embed-js-step">Step 1: Select Your Bot</h2>
      <p className="embed-js-intro">
        Navigate to <strong>Your Bots</strong> in the Xenachat dashboard and select the chatbot you wish to integrate.
      </p>

      <h2 className="embed-js-step">Step 2: Access Connect Settings</h2>
      <p className="embed-js-intro">
        Click on the <strong>Connect</strong> button located in the left sidebar. The JavaScript snippet will be displayed in a dedicated code block.
      </p>

      <h2 className="embed-js-step">Step 3: Copy the Snippet</h2>
      <p className="embed-js-intro">
        Click the <strong>Copy</strong> button adjacent to the snippet to copy it to your clipboard. Below is a sample snippet for reference:
      </p>

      <pre className="embed-js-code">
{`<!-- XenaChat inline widget -->
<script id="xenachat-script">
(function(){
    
})();
</script>`}
      </pre>

      <h2 className="embed-js-step">Step 4: Using React</h2>
      <p className="embed-js-intro">
        When using React, do not include the <code>{'<script>...</script>'}</code> directly in JSX. Instead, dynamically create a <code>&lt;script&gt;</code> element within a <code>useEffect</code> hook, assign the snippet content to <code>innerHTML</code>, and append it to <code>document.body</code>.
      </p>
    </div>
  );
};

export default EmbedJsSnippet;